<template>
  <div class="groupsPrdtListing">
    <section class="detail_content">
      <ul class="list_panel" v-if="availableGroupList.length > 0">
        <li v-for="(availGroups,index) in availableGroupList" :key="index">
          <router-link
            :to="`/detail/${ availGroups.saleReferenceID}`"
            tag="span"
            class="img_wrapper"
          >
            <img :src="availGroups.displayImage" :alt="availGroups.itemName" />
          </router-link>
          <div class="product_detail">
            <h3 class="name">{{availGroups.itemName}}</h3>
            <p
              class="location"
            >{{$t('onBuyGetDiscount', {memberCount: availGroups.minGroupCount, discountPrice:availGroups.pricingDTO.groupDiscount})}}</p>
            <div class="group_price_detail flx">
              <p>
                <span class="group_price">₹{{availGroups.pricingDTO.totalPaidAmount}}</span>
                <span class="actual_price">₹{{availGroups.pricingDTO.sellingPrice}}</span>
              </p>
              <span
                class="buy_now"
                @click="startGroup(availGroups.saleReferenceID ,availGroups.productId)"
              >{{$t('addNow')}}</span>
            </div>
          </div>
          <p class="buy_now"></p>
        </li>
      </ul>
      <NoDataFound
        v-if="noData == true && this.availableGroupList && this.availableGroupList == 0"
      />
      <infinite-loading @infinite="groupsAvailProducts" spinner="circles">
        <template slot="no-results">{{$t('noMoreRecord')}}</template>
      </infinite-loading>
    </section>

    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import NoDataFound from "../../components/Common/NoDataFound";
export default {
  name: "GroupsProductListing",
  components: {
    NoDataFound
  },
  data() {
    return {
      availableGroupList: [],
      availableGroupIndex: 0,
      loading: false,
      noData: false
    };
  },
  methods: {
    groupsAvailProducts($state) {
      this.$store
        .dispatch({
          type: "getAvailGroupsProduct",
          payload: this.availableGroupIndex
        })
        .then(data => {
          this.loading = false;
          if (data.data.merchandiseGroupDTOs.length > 0) {
            this.availableGroupIndex += 1;
            this.availableGroupList.push(...data.data.merchandiseGroupDTOs);
            this.$store.commit("saveAvailProductGroups", {
              availGroupListData: this.availableGroupList,
              availGroupIndex: this.availableGroupIndex + 1
            });
            $state && $state.loaded();
            // this.noData = false
          } else {
            this.noData = true;
            $state && $state.complete();
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    startGroup(itemId, productId) {
      try {
        JSBridgePlugin.fireEvents("ITEM_GROUP_LISTING");
      } catch (err) {
        console.log(err);
      }
      this.$router.push(
        "/group-list/?productId=" + productId + "&itemId=" + itemId
      );
    }
  },
  mounted() {
    this.loading = true;
  }
};
</script>
    